import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Baseproperties } from '../../utility/baseproperties';

@Injectable({
  providedIn: 'root'
})
export class CommonmastersauditlogService {
  constructor(private httpClient: HttpClient) { }
  baseproperties: Baseproperties = new Baseproperties();
  private baseURL = this.baseproperties.gatewayBaseURL + "/common/commonmastersauditlog"


  getmodifiedby(payload): Observable<any> {
    return this.httpClient.post(`${this.baseURL}/getmodifiedby/`, payload);
  }

  getmodifiedrow(payload): Observable<any> {
    return this.httpClient.post(`${this.baseURL}/getmodifiedrow/`, payload);
  }

  getdeletedby(payload): Observable<any> {
    return this.httpClient.post(`${this.baseURL}/getdeletedby/`, payload);
  }

  getTableData(payload): Observable<any> {
    return this.httpClient.post(`${this.baseURL}/gettabledata/`, payload);
  }

  getMasterRow(payload): Observable<any> {
    return this.httpClient.post(`${this.baseURL}/getmasterrow/`, payload);
  }

  getDeletedMasterRow(payload): Observable<any> {
    return this.httpClient.post(`${this.baseURL}/getdeletedmaster/`, payload);
  }
  getExcelData(payload) {
    return this.httpClient.post(`${this.baseURL}/getexceldata`, payload, { responseType: 'blob' });
  }

}
